import $ from 'jquery';
import config from '../config.mjs';
import template from '../../../html/_includes/components/opening-hours.hbs';
import {getCurrentOpeningFromStore} from '../utilities/store-opening.mjs';
import ServerTime from './ServerTime.mjs';
import {getTranslation, translations} from '../utilities/translations.mjs';

export default class OpeningHours {
  constructor(store) {
    this.currentDateTime = new Date();
    this.store = store;
    this.$node = null;
  }

  render() {
    return new Promise((resolve) => {
      ServerTime.get()
        .then((serverTime) => {
          // Use server time
          this.currentDateTime = new Date(serverTime.iso);
          resolve(renderInternal.call(this));
        })
        .catch((result) => {
          // Fallback to without server time
          resolve(renderInternal.call(this));
        });
    });
  }
}

function renderInternal() {
  const {
    isOpen,
    isClosingSoon,
    openTime,
    closeTime,
  } = getCurrentOpeningFromStore.call(this, this.store);

  this.$node = $(template({
    "imageDirectoryPath": config.imageDirectoryPath,
    "iconId": "clock",
    "headline": getTranslation(translations.OpeningHours.HEADING),
    "textWeekDay": getTranslation(translations.OpeningHours.TEXT_WEEK_DAY),
    "textTimes": getTranslation(translations.OpeningHours.TEXT_TIMES),
    "textClosed": getTranslation(translations.OpeningHours.TEXT_CLOSED),
    "textCurrent": getTranslation(translations.OpeningHours.TEXT_CURRENT),
    "textToday": getTranslation(translations.OpeningHours.TEXT_TODAY),
    "currentDayOpening": getCurrentDayOpening(isOpen, openTime, closeTime),
    "listItem": getListItems.call(this),
    "openStatus": getOpenStatus(isOpen, isClosingSoon),
    "open": isOpen && !isClosingSoon,
    "closed": !isOpen,
    "soonClosed": isClosingSoon
  }));

  attachEvents.call(this);

  return this.$node;
}

function getCurrentDayOpening(isOpen, openTime, closeTime) {
  if (!isOpen || !openTime || !closeTime) {
    return '';
  }

  return `${openTime} - ${closeTime}`;
}

function getListItems() {
  const currentWeekDay = this.currentDateTime;
  const store = this.store;
  const listForNext7Days = [];

  for (let i = 0; i < 7; i++) {
    const currentWeekDayString = currentWeekDay.toLocaleDateString('en', {weekday: 'long'}).toUpperCase();
    const regularHours = store.regularHours.periods;
    const isCurrentDay = i === 0;

    // Collect regular openings
    regularHours.forEach((period) => {
      // Is current day of the week
      if (period.openDay !== currentWeekDayString) {
        return;
      }

      const [openHours, openMinutes] = period.openTime.split(':');
      const [closeHours, closeMinutes] = period.closeTime.split(':');

      if (typeof listForNext7Days[i] == 'undefined') {
        listForNext7Days[i] = {
          "currentDay": isCurrentDay,
          "day": currentWeekDay.toLocaleDateString(
            document.documentElement.lang,
            {weekday: 'long'}
          ),
          "openingTime": `${openHours}:${openMinutes} - ${closeHours}:${closeMinutes}`,
        };
      } else {
        // Append multiple openings per day
        listForNext7Days[i]['openingTime'] += `<br /> ${openHours}:${openMinutes} - ${closeHours}:${closeMinutes}`;
      }
    });

    // Add day if not defined (like sunday)
    const isNotDayDefinedByRegularHours = typeof listForNext7Days[i] === 'undefined';

    if (isNotDayDefinedByRegularHours) {
      listForNext7Days[i] = {
        "currentDay": isCurrentDay,
        "day": currentWeekDay.toLocaleDateString(
          document.documentElement.lang,
          {weekday: 'long'}
        ),
        "openingTime": "",
      };
    }

    // Override with special openings
    store.specialHours.specialHourPeriods.forEach((period) => {
      // Is open
      if (period.isClosed === false) {
        return;
      }

      const openDateTime = new Date();
      openDateTime.setFullYear(parseInt(period.startDate.year));
      openDateTime.setMonth(parseInt(period.startDate.month) - 1);
      openDateTime.setDate(parseInt(period.startDate.day));

      // Is current day of the week
      if (openDateTime.toDateString() !== currentWeekDay.toDateString()) {
        return;
      }

      // Existing day in list
      if (typeof listForNext7Days[i] === 'undefined') {
        return;
      }

      // Set current week day to closed
      listForNext7Days[i]['openingTime'] = "";
    });

    if (i === 0 && store.temporary_closed === true) {
      // Set current day to closed
      listForNext7Days[i]['openingTime'] = "";
    }

    // + 1 day for the next run
    currentWeekDay.setDate(currentWeekDay.getDate() + 1);
  }

  return listForNext7Days;
}

function getOpenStatus(isOpen, isClosingSoon) {
  const textClosed = getTranslation(translations.OpeningHours.TEXT_CLOSED);
  let openStatus = textClosed.charAt(0).toUpperCase() + textClosed.slice(1);

  if (isOpen && !isClosingSoon) {
    openStatus = getTranslation(translations.OpeningHours.TEXT_OPEN);
  } else if (isOpen && isClosingSoon) {
    openStatus = getTranslation(translations.OpeningHours.TEXT_CLOSING_SOON);
  }

  return openStatus;
}

function attachEvents() {
  const $presentView = this.$node.find('.opening-hours__present-view');
  const $listView = this.$node.find('.opening-hours__list-view');
  const $presentViewButton = $presentView.find('.opening-hours__button');
  const $listViewButton = $listView.find('.opening-hours__button');

  $presentViewButton.on('click', switchToListView.bind(this, $presentView, $listViewButton, $listView));
  $listViewButton.on('click', switchToPresentView.bind(this, $presentViewButton, $presentView, $listView));
}

function switchToListView($presentView, $listViewButton, $listView) {
  $presentView.addClass('d-none');
  $listView.removeClass('d-none');
  $listViewButton.focus()
}

function switchToPresentView($presentViewButton, $presentView, $listView) {
  $listView.addClass('d-none');
  $presentView.removeClass('d-none');
  $presentViewButton.focus();
}
